import 'css-chunksrc/client/scenes/projectReportRemoval/styles.scss';export default {
  "header": "_header_9bzh5_1",
  "group": "_group_9bzh5_5",
  "text": "_text_9bzh5_9",
  "name": "_name_9bzh5_14",
  "main": "_main_9bzh5_20",
  "buttons": "_buttons_9bzh5_27"
};